import useJwt from '@/auth/jwt/useJwt'

const decodeJwtPayload = token => {
  try {
    const parts = String(token || '').split('.')
    if (parts.length < 2) return null
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
    const json = atob(padded)
    return JSON.parse(json)
  } catch (_) {
    return null
  }
}

const clearAuthStorage = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
  localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
}

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  const userDataRaw = localStorage.getItem('userData')
  const token = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
  if (!userDataRaw || !token) return false

  const payload = decodeJwtPayload(token)
  if (!payload || !payload.exp) {
    clearAuthStorage()
    return false
  }

  const nowSec = Math.floor(Date.now() / 1000)
  if (Number(payload.exp) <= nowSec) {
    clearAuthStorage()
    return false
  }

  return true
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'aluno') return { name: 'courses' }
  return { name: 'DashboardChat' }
}
